<template>
    <modal id="hotel-lost-found-modal"
           size="large"
           v-model="showModal"
           :title="generateModalTitle('lost_and_found')"
           @submit="submitData" :loading="loading"
           :preloader="preloader">

        <form
            ref="form"
            :data-url='selectedUrl ? selectedUrl : `${TENANT_BASE_URL}app/hotel/lost-found`'
            @submit.prevent="submitData"
        >
            <div class="row">
                <div class="col-md-6" v-if="!hotel_id">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('hotel')"
                        list-value-field="name"
                        v-model="formData.hotel_id"
                        :required="true"
                        :chooseLabel="$t('hotel')"
                        :error-message="$errorMessage(errors, 'hotel_id')"
                        :fetch-url="`${TENANT_BASE_URL}selectable/hotel/list`"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('room')"
                        list-value-field="name"
                        v-model="formData.room_id"
                        :required="true"
                        :chooseLabel="$t('room')"
                        :error-message="$errorMessage(errors, 'room_id')"
                        :fetch-url="room_url"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        type="date"
                        :label="$t('date')"
                        v-model="formData.date"
                        :placeholder="formData.date ? $placeholder('date') : this.$t('not_added_yet')"
                        :error-message="$errorMessage(errors, 'date')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('status')"
                        list-value-field="name"
                        v-model="formData.status"
                        :required="true"
                        :chooseLabel="$t('status')"
                        :error-message="$errorMessage(errors, 'status')"
                        :fetch-url="`${TENANT_BASE_URL}selectable/hotel/lost-found-status`"
                    />
                </div>
                <div class="col-md-12">
                    <app-form-group
                        type="textarea"
                        :label="$t('note')"
                        :placeholder="$textAreaPlaceHolder('note')"
                        v-model="formData.note"
                        :required="false"
                        :error-message="$errorMessage(errors, 'note')">
                    </app-form-group>
                </div>
                <div class="col-md-12">
                    <app-form-group
                        type="textarea"
                        :label="$t('remark')"
                        :placeholder="$textAreaPlaceHolder('remark')"
                        v-model="formData.remark"
                        :required="false"
                        :error-message="$errorMessage(errors, 'remark')">
                    </app-form-group>
                </div>

                <div class="col-md-12">
                    <div class="form-group">
                        <label>{{ $t('attachments') }}</label>
                        <app-input
                            type="dropzone"
                            v-model="files"
                            :error-message="$errorMessage(errors, 'files.0')"
                        />
                    </div>
                </div>

                <div class="col-md-12" v-if="current_files.length">
                    <div class="form-group">
                        <label>{{ $t('current_files') }}</label>
                        <div class="img-container">
                            <div class="img-box" v-for="(url, index) in current_files" :key="'current-image-' + index">
                                <img v-if="isImage(url)"
                                    :src="url"
                                    class="img-thumbnail"
                                    :title="getFileName(url)"
                                />
                                <div v-else
                                    :href="url"
                                    target="_blank"
                                    class="d-flex align-items-center justify-content-center text-truncate img-thumbnail"
                                    :title="getFileName(url)"
                                >
                                    <i :class="`fa fa-file-${getFileExtension(url).substring(1)}`"></i>
                                </div>
                                <div class="img-action">
                                    <button type="button" class="btn btn-sm btn-primary" @click="viewFile(url)" :title="$t('view')">
                                        <i class="fas fa-eye"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {formDataAssigner} from "../../../../../common/Helper/Support/FormHelper";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";
import {formatDateForServer} from "../../../../../common/Helper/Support/DateTimeHelper";

export default {
    name  : "HotelLostFoundCreateModal",
    mixins: [FormHelperMixins, ModalMixin],
    props : {
        hotel_id: {
            default: null
        }
    },
    data() {
        return {
            TENANT_BASE_URL,
            files   : [],
            room_url: null,
            current_files: [],
            formData: {
                status  : 1,
                hotel_id: this.hotel_id ? this.hotel_id : 0,
            },
        }
    },
    watch  : {
        'formData.hotel_id': {
            handler  : function (hotel_id) {
                this.room_url = `${TENANT_BASE_URL}selectable/hotel/room?hotel_id=${typeof hotel_id !== "undefined" ? hotel_id : 0}`
            },
            immediate: true
        }
    },
    methods: {
        submitData() {
            this.loading       = true
            this.formData.date = this.formData.date ? formatDateForServer(this.formData.date) : '';

            let url      = this.$refs.form.dataset["url"];
            let formData = formDataAssigner(new FormData, this.formData);

            this.files.forEach(file => formData.append('files[]', file))

            if (this.selectedUrl) {
                // for file update need to send by post.
                formData.append('_method', 'PATCH');
            }

            if (this.hotel_id) {
                formData.append('hotel_id', this.hotel_id);
            }
            this.loading = true;

            this.submitFromFixin('post', url, formData);
        },
        afterSuccess({data}) {
            this.formData = {};
            $('#hotel-lost-found-modal').modal('hide');
            this.$emit('input', false);
            this.toastAndReload(data.message, 'hotel-lost-found-table');
        },
        afterSuccessFromGetEditData(response) {
            this.preloader = false;
            this.current_files = response.data.files || [];
            this.formData  = response.data;
        },
    },
}
</script>

